<template>
  <el-card class="page-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="carNumber">
          <el-input v-model="form.carNumber" placeholder="车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="deviceName">
          <el-input v-model="form.deviceName" placeholder="设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="deviceCode">
          <el-input v-model="form.deviceCode" placeholder="设备编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="actionType">
          <el-select v-model="form.actionType" clearable placeholder="动作">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="进入" :value="1"></el-option>
            <el-option label="离开" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="" prop="areaCode">
          <el-input v-model="form.areaCode" placeholder="区域名称" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="" prop="dateTime">
          <el-date-picker
            v-model="form.dateTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
          <!-- <el-button type="default" @click="exportFile">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border stripe height="calc(100% - 110px)" v-loading="tableLoading">
      <el-table-column label="序号" prop="seqNo" width="150" :align="alignType"></el-table-column>
      <el-table-column label="车牌号" prop="carNumber" :align="alignType"></el-table-column>
      <el-table-column label="设备名称" prop="deviceName" :align="alignType"></el-table-column>
      <el-table-column label="设备编码" prop="deviceCode" :align="alignType"></el-table-column>
      <el-table-column label="动作" prop="name" :align="alignType">
        <template slot-scope="{ row }">
          {{ row.actionType === 1 ? '进入' : '离开' }}
        </template></el-table-column
      >
      <el-table-column label="动作时间" prop="actionTime" :align="alignType"></el-table-column>
      <!-- <el-table-column label="区域名称" prop="areaName" :align="alignType"></el-table-column> -->
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import tableHeightMixin from '@/mixins/tableHeightMixin'
import devaspService from '@/services/pageService/devasp'

import { IOTBarrierGateAccessRecordApi } from '@wiz-api/iot-device-management'

const iotBarrierGateAccessRecordApi = new IOTBarrierGateAccessRecordApi()

export default {
  name: 'BarrierGateRecord',
  mixins: [tableHeightMixin],
  data() {
    return {
      pIid: '',
      facturerList: [],
      deviceTypeList: [],
      factureMap: {},
      deviceTypeMap: {},
      alignType: 'left',
      form: {
        carNumber: '',
        deviceName: '',
        deviceCode: '',
        actionType: '',
        areaCode: '',
        dateTime: [],
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      areaMapCodeToName: {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // await this.getAera()
      await this.getList()
    },
    async getAera() {
      const [err, res] = await devaspService.getAera({
        token: 'portal_js',
      })
      if (!err) {
        // console.log(this.unflatten(res.data.items))
        const aeraList = res.data.items
        if (Array.isArray(aeraList)) {
          aeraList.forEach((item) => {
            this.areaMapCodeToName[item.pr_code] = item.pr_name
          })
        }
      }
    },
    formatDate(row, column, cellValue) {
      if (cellValue) return this.dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
      this.getList()
    },
    async getList() {
      const res = await iotBarrierGateAccessRecordApi.getPageList({
        ...this.form,
        startTime: this.form.dateTime?.[0]
          ? this.dayjs(this.form.dateTime[0]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        endTime: this.form.dateTime?.[1]
          ? this.dayjs(this.form.dateTime[1]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (res[1]) {
        res[1].items.forEach((item, index) => {
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)
          item.actionTime = item.time ? this.dayjs(item.time).format('YYYY-MM-DD HH:mm:ss') : null
        })
        this.tableData = res[1].items || []
        this.initPagination.total = res[1].totalCount
      }
    },
    // 导出
    exportFile() {},
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
